<template>
  <div class="app-tariff-option-box">
    <BookableDetailsWithActions
      v-if="option"
      :details="compileTariff.details"
      :actions="compileTariff.actions"
      :info="compileTariff.info"
      :content-theme="option.tariffoptionId"
      :box-theme="'light'"
      @click:details="$emit('details', option.tariffoptionId)"
      @click:action="$emit('details', option.tariffoptionId)"
    >
    </BookableDetailsWithActions>
  </div>
</template>
<script>

import BookableDetailsWithActions from '@/components/process/generic/Tariff/generic/CurrentTariff/DetailsWithActions.vue'
import durationUnit from '@/mixins/durationUnit'
export default {
  name: 'TariffOptionsBox',
  components: { BookableDetailsWithActions },
  data () {
    return {
      tariff: []
    }
  },
  methods: {
    createDetails (option) {
      let amount
      if (option.duration.amount === null || option.duration.amount === 0) {
        amount = null
      } else {
        amount = '/' + option.duration.amount + ' ' + this.durationUnit(option.duration.unit.toUpperCase(), option.duration.amount)
      }
      if (option.tariffoptionId === 'CCS_92050') {
        amount = '/ 03.01.2024'
      }
      return [
        ...option.tariffExtra?.volumes || [],
        {
          primary: option.formattedPrice,
          secondary: amount
        }]
    },
    createInfo (option) {
      return {
        name: option.name,
        info: option.tariffState
      }
    },
    activatable () {
      return this.option.__typename === 'BookableTariffoption' && !this.option.cancelable && !this.doubleDataPromo.includes(this.option.tariffoptionId)
    },
    deactivatable () {
      return this.option.__typename === 'BookedTariffoption' && this.option.cancelable && this.option.statusKey !== 'TER' && !this.doubleDataPromo.includes(this.option.tariffoptionId)
    },
    createButtons () {
      return [
        { type: 'details', text: 'Details anzeigen' },
        ...this.deactivatable() ? [{ type: 'action', text: 'Deaktivieren', disabled: this.isDisabled() }] : [],
        ...this.activatable() ? [{ type: 'action', text: 'Aktivieren', disabled: this.isDisabled() }] : []
      ]
    },
    isDisabled () {
      if (this.clicked.length > 0) {
        return this.clicked.indexOf(this.option.tariffoptionId) !== -1
      } else {
        return false
      }
    }
  },
  computed: {
    compileTariff: function () {
      return {
        details: this.createDetails(this.option),
        info: this.createInfo(this.option),
        actions: this.createButtons(this.option)
      }
    },
    doubleDataPromo: function () {
      return [
        'CCS_92055',
        'CCS_92056',
        'CCS_92057'
      ]
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    clicked: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    durationUnit
  ]
}
</script>
